module.exports = __webpack_public_path__ + "static/media/rdd.673ad4b6.svg";